import React from "react";
import Modal from "../../../../elements/Modal";
import ManageQuiz from "../ManageQuiz";

const ManageQuizModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update" : "Create New "}
    >
      <ManageQuiz getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageQuizModal;
